export default class Deposit {

    constructor(item) {
        this._item = this.changeOptions(item);
    }

    get raw() {
        return this._item;
    }

    changeOptions(item){
        this.procType(item);
        this.cmsMessage(item)
        this.userFullname(item);

        return item;
    }


    procType(item){
        if(item.procType === 'R'){
            item.procTypeName = '환불';
        } else {
            item.procTypeName = '입금';
        }

        return this;
    }

    cmsMessage(item){
        if(!!item.paymentProcess){
            if(item.memberAcctPause === 'Y'){
                item.cmsStatus = '일시정지';
            } else if(item.memberProcType !== 'D' && item.memberResultYn === 'Y'){
                item.cmsStatus = '사용중';
            } else if (item.memberProcType === 'N' && (item.memberResultYn === 'R' || item.memberResultYn === 'P')) {
                item.cmsStatus = '등록처리중';
            } else if ((item.memberProcType === 'N' || item.memberProcType === 'U') && item.memberResultYn === 'N'){
                item.cmsStatus = '등록실패';
            } else if (item.memberProcType === 'U' && (item.memberResultYn === 'R' || item.memberResultYn === 'P')){
                item.cmsStatus = '변경처리중';
            } else if (item.memberProcType === 'D' && (item.memberResultYn === 'R' || item.memberResultYn === 'P')){
                item.cmsStatus = '해지처리중';
            } else if (item.memberProcType === 'D' && item.memberResultYn === 'Y'){
                item.cmsStatus = '해지';
            }
        } else {
            item.cmsStatus = '-';
        }
        return this;
    }

    userFullname(item){
        if(!!item.userFullname){
            item.registerUserName = item.userFullname;
        } else if(item.register.includes('batchauto') || item.register.includes('mig')) {
            item.registerUserName = 'SYSTEM';
        } else {
            item.registerUserName = '-';
        }

        return this;
    }


}
